export default {
    prescription: 'Предписание',
};
